export default __webpack_public_path__ + "static/media/pencil-cold-summer.df2886ec.png";